/* global jQuery, dokan_order_min_max */
import OrderMinMaxFormValidation from './../order-min-max-form-validation';

( function ( $ ) {
    $( document ).ready( function () {
        // eslint-disable-next-line camelcase
        const settings = dokan_order_min_max || {};

        /**
         * Product quick edit
         *
         * @since 3.12.0
         */
        $( '#the-list' ).on( 'click', '.editinline', function () {
            let productId = $( this ).closest( 'tr' ).attr( 'id' );
            productId = productId.replace( 'post-', '' );
            const minMaxMetaData = $( `#post-${ productId } .${ settings.constants.QUICK_EDIT_META_DATA }` ).data( 'min-max-data' );

            const minimumQuantityField = $( `#edit-${ productId } .${ settings.constants.QUICK_EDIT_MINIMUM_QUANTITY }` );
            const maximumQuantityField = $( `#edit-${ productId } .${ settings.constants.QUICK_EDIT_MAXIMUM_QUANTITY }` );

            minimumQuantityField.val( minMaxMetaData.min_quantity );
            maximumQuantityField.val( minMaxMetaData.max_quantity );

            new OrderMinMaxFormValidation(
                minimumQuantityField,
                maximumQuantityField
            );
        } );

        /**
         * Product bulk edit
         *
         * @since 3.12.0
         */
        $( '#doaction' ).on( 'click', function () {
            if ( 'edit' === $( '#bulk-action-selector-top' ).val() ) {
                const minimumQuantityField = $( `.inline-edit-wrapper .${ settings.constants.QUICK_EDIT_MINIMUM_QUANTITY }` );
                const maximumQuantityField = $( `.inline-edit-wrapper .${ settings.constants.QUICK_EDIT_MAXIMUM_QUANTITY }` );
                new OrderMinMaxFormValidation( minimumQuantityField, maximumQuantityField );
            }
        } );

        /**
         * Simple product min max section form validation
         *
         * @since 3.12.0
         */
        $( `.${ settings.constants.SIMPLE_PRODUCT_MIN_MAX_WRAPPER }` ).ready(
            function () {
                const minimumQuantityField = $( `.${ settings.constants.SIMPLE_PRODUCT_MIN_MAX_WRAPPER } #${ settings.constants.SIMPLE_PRODUCT_MIN_QUANTITY }` );
                const maximumQuantityField = $( `.${ settings.constants.SIMPLE_PRODUCT_MIN_MAX_WRAPPER } #${ settings.constants.SIMPLE_PRODUCT_MAX_QUANTITY }` );
                new OrderMinMaxFormValidation( minimumQuantityField, maximumQuantityField );
            }
        );

        /**
         * Variable product min max section form validation
         *
         * @since 3.12.0
         */
        $( document ).on( 'woocommerce_variations_loaded', function () {
            const variationMinMaxFieldList = $( `.${ settings.constants.VARIATION_PRODUCT_MIN_MAX_WRAPPER }` );
            variationMinMaxFieldList.map( ( index, value ) => {
                const minimumQuantityField = $( value ).find( `.${ settings.constants.VARIATION_PRODUCT_MIN_QUANTITY }` );
                const maximumQuantityField = $( value ).find( `.${ settings.constants.VARIATION_PRODUCT_MAX_QUANTITY }` );

                new OrderMinMaxFormValidation( minimumQuantityField, maximumQuantityField );
            } );
        } );
    } );
} )( jQuery );
